import {
    Component,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
} from '@angular/core';
import { of, Subject, Subscription } from 'rxjs';
import { catchError, filter, finalize, switchMap, tap } from 'rxjs/operators';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { TdbfgComplianceDetailsPopup } from './tdbfg-compliance-details.widget.model';
import { TdbfgCompliancePopupUser } from './tdbfg-compliance.widget.model';

@Component({
    selector: 'cmps-widget-tdbfg-compliance-details',
    templateUrl: './tdbfg-compliance-details.widget.component.html',
})
export class TdbfgComplianceDetailsWidgetComponent
    implements OnChanges, OnDestroy
{
    @Input() user: TdbfgCompliancePopupUser;
    @Input() widgetId: number;
    @Input() activeTabId: string;

    i18n = TranslationKeyMap;
    private readonly _subject: Subject<TdbfgCompliancePopupUser>;
    private readonly _sub: Subscription;
    hasPendingData: boolean;
    data: TdbfgComplianceDetailsPopup;

    constructor(private readonly _service: LegacyWidgetService) {
        this._subject = new Subject();
        this._sub = this._subject
            .asObservable()
            .pipe(
                filter((user) => !!user),
                // eslint-disable-next-line no-return-assign
                tap(() => (this.hasPendingData = true)),
                switchMap((user) =>
                    this._service
                        .tdbfgComplianceDetailsPopup(
                            user.id,
                            user.superGroupId,
                            this.widgetId,
                        )
                        .pipe(catchError(() => of(null))),
                ),
                tap((data) => {
                    this.data = data;
                    this.hasPendingData = false;
                }),
                // eslint-disable-next-line no-return-assign
                finalize(() => (this.hasPendingData = false)),
            )
            .subscribe();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('user') && this._subject) {
            this._subject.next(this.user);
        }
    }

    ngOnDestroy(): void {
        if (this._sub) {
            this._sub.unsubscribe();
        }
    }
}
